import { render, staticRenderFns } from "./reviewReject.vue?vue&type=template&id=1cfb934a&scoped=true"
import script from "./reviewReject.vue?vue&type=script&lang=js"
export * from "./reviewReject.vue?vue&type=script&lang=js"
import style0 from "./reviewReject.vue?vue&type=style&index=0&id=1cfb934a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb934a",
  null
  
)

export default component.exports